<template>
    <div>
        <tab name="2"></tab>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <city-select :value.sync="params.cityCode" default-query="北京" :default-query-call-back="fetch" size="small"></city-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.isShow" placeholder="请选择" size="small">
                        <el-option label="不限" value=""></el-option>
                        <el-option label="展示" :value="1"></el-option>
                        <el-option label="隐藏" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="fetch" size="small">查询</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <div class="gantt-example">
                <span class="show-time">开演日期</span>
                <span class="end">展示中(已过期)</span>
                <span class="start">展示中</span>
                <span class="hide">隐藏中</span>
            </div>
        </div>
        <div class="page-list-box">
            <wl-gantt
                dateType="monthAndDay" 
                :data="ganttData" 
                :useRealTime="true"
                :loading="fetchLoading"
                :startDate="startDate" 
                :highlightCurrentRow="true"
                @taskAdd="setDisplay"
                @taskRemove="setDisplay"
                :edit="false"
                :rowClassName="onRowClassName"
                :endDate="endDate"></wl-gantt>
        </div>
        <div v-if="ganttData.length > 0" class="page-pagination-box">
            <el-pagination
                background
                @size-change="search"
                @current-change="fetch"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import Tab from '../components/tab'
import CitySelect from '@/components/CitySelect';
import WlGantt from '@/components/WlGantt';
import dayjs from 'dayjs';
const defaultQuery = {
    cityCode: '',
    isShow: '',
    pageNo: 1,
    pageSize: 15
};
export default {
    components: {
        Tab,
        CitySelect,
        WlGantt
    },
    data() {
        return {
            params: {...defaultQuery},
            fetchLoading: false,
            tableData: [],
            totalCount: 0,
            startDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
            endDate: dayjs().add(7, 'days').format('YYYY-MM-DD HH:mm:ss'),
            ganttData: []
        };
    },
    methods: {
        async fetch() {
            this.fetchLoading = true;
            const response = await this.$request({
                url: "/diagram/advertisement/list",
                method: "POST",
                data: this.params,
            })
            const {state, msg, result} = response.data;
            this.fetchLoading = false;
            if (state != 1) return this.$message.error(msg);
            this.startDate = result.startDate;
            this.endDate = dayjs(result.startDate).add(result.days, 'days').format('YYYY-MM-DD HH:mm:ss');
            if(result.pageResult && result.pageResult.result.length > 0) {
                const data = result.pageResult.result.map(day => {
                    return {
                        name: day.title,
                        id: day.id,
                        startDate: day.startDate,
                        endDate: day.autoDeleteTime,
                        isShow: day.isShow,
                        realStartDate: day.showStartDate,
                        realEndDate: day.showStartDate
                    }
                })
                this.totalCount = result.pageResult.totalCount;
                this.ganttData = data;
            }
        },
        async setDisplay (row) {
            const response = await this.$request({
                url: "/diagram/advertisement/up_show",
                method: "POST",
                data: {id: row.id, type: row.isShow === 1 ? 2 : 1},
            })
            const {msg, state} = response.data;
            this.btnLoading = false;
            if (state != 1) return this.$message.error(msg);
            this.fetch();
        },
        onRowClassName ({row}) {
            if (row.isShow === 2) return 'hide-wl-row';
            return '';
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.fetch();
        }
    },
};
</script>
<style lang="scss" scoped>
.gantt-example {
    text-align: right;
    span {
        margin-left: 30px;
        position: relative;
        &::before {
            content: "";
            width: 5px;
            height: 5px;
            position: absolute;
            left: -10px;
            top: 6px;
            background: #e2e0e0;
        }
        &.end::before {
            background: #b6e2d1;
        }
        &.show-time::before {
            background: #faa792;
        }
        &.start::before {
            background: #1fbb7d;
        }
    }
}
</style>

